<template>
  <div>
    <div class="selectTool" v-show="listselects.includes('area')">
      <el-select v-model="shengValue" clearable :disabled="disabled1==true" placeholder="请选择省" @change="shengChange"  size="mini">
        <el-option v-for="item in sheng" :key="item.regionCode" :label="item.regionName" :value="item.regionCode">
        </el-option>
      </el-select>
      <el-select v-model="shiValue" clearable :disabled="disabled2==true" placeholder="请选择市" @change="shiChange" size="mini">
        <el-option v-for="item in shi" :key="item.regionCode" :label="item.regionName" :value="item.regionCode">
        </el-option>
      </el-select>
      <el-select v-model="xianValue" clearable :disabled="disabled3==true" placeholder="请选择县" @change="xianChange" size="mini">
        <el-option v-for="item in xian" :key="item.regionCode" :label="item.regionName" :value="item.regionCode">
        </el-option>
      </el-select>
    </div>
    <!-- <el-switch class="elSwitch1" style="display: block" v-model="value1" active-color="#13ce66" inactive-color="#409eff"
      active-text="下游有人淤地坝" inactive-text="全部淤地坝" @change="switchChange1">
    </el-switch> -->
    <el-switch class="elSwitch" style="display: block" v-model="value" active-color="#13ce66" inactive-color="#409eff" active-text="显示全部淤地坝" inactive-text="过滤显示" @change="switchChange" v-show="listselects.includes('allYdb')">
    </el-switch>
    <el-switch class="new_elSwitch" style="display: block" v-model="new_value" active-color="#13ce66" inactive-color="#409eff" active-text="显示新建淤地坝" inactive-text="" @change="newswitchChange" v-show="listselects.includes('newYdb')">
    </el-switch>
    <el-button class="new_button" v-if="new_value" size="mini" @click="showNewYdbFn">展示新建淤地坝</el-button>
    <el-switch class="elSwitch2" style="display: block" v-model="value2" active-color="#13ce66" inactive-color="#409eff" active-text="粗泥沙集中来源区图层" inactive-text="" @change="switchChange2" v-show="listselects.includes('cunisha')">
    </el-switch>
    <el-switch class="elSwitch3" style="display: block" v-model="value3" active-color="#13ce66" inactive-color="#409eff" active-text="多沙粗沙区图层" inactive-text="" @change="switchChange3" v-show="listselects.includes('duoshacusha')">
    </el-switch>
    <!-- 显示监控设备的点 -->
    <el-switch class="elSwitch2" style="display: block" v-model="value4" active-color="#13ce66" inactive-color="#409eff" active-text="显示监控淤地坝图层" inactive-text="" @change="switchChange4" v-show="listselects.includes('monitor')">
    </el-switch>

  </div>
</template>
<script>
import {
  initRegion,
  getRegion
} from '@/api/api.js'
import {
  getChartStatsData,
  getChartStatsSinData,
  getDsManData,
  getNewDamData,
  getQueryDamDisData
} from '@/api/inSeriesApi'
import { canvasMarkerLayer } from '@/utils/canvasMarkerLayer'
export default {
  props: ['map', 'beforeCode', 'listselects'],
  data() {
    return {
      disabled1: false,
      disabled2: false,
      disabled3: false,
      sheng: [],
      shi: [],
      xian: [],
      shengValue: '',
      shiValue: '',
      xianValue: '',
      shengCode: '',
      shiCode: '',
      xianCode: '',

      value: true,
      value1: false,
      value2: false,
      value3: false,
      new_value: false,
      value4: true,

      switchShow: true,

      monitorMarkerLayer: null,
      paramsSingleDam: {
      //下游有人
      xyyr: false,
      // 重要设施
      zyss: false,
      //有蓄水
      yxs: false,
      //有监控
      yjk: false,
      //有预案
      yya: false,
      //黄委直管
      hwzg: false,
      //大型坝
      dxDam: false,
      //中型坝
      zxDam: false,
      //小型坝
      xxDam: false,
      //省
      provinceCode: '',
      //市
      cityCode: '',
      // 县
      countyCode: ''
    }
    }
  },
  mounted() {
    // console.log('---------------->', this.listselects)
    // if (this.listselects == false) {
    //   this.switchShow = false;
    // } else {
    //   this.switchShow = true;
    // }

    // this.initRegionFun();
    if(this.$route.path == "/safetymonitoring"){
      this.switchChange4(this.value4)
    }
  },
  computed: {
    nowxingzhengCodes() {
      return this.$store.state.nowxingzhengCode; //需要监听的数据
    },
  },
  watch: {
    beforeCode(data) {
      console.log(data, 'beforeCode')
      if (data) {
        this.shengValue = ''
        this.shi = ''
        this.xian = ''
      }
    },
    shiValue(data) {
      if (data == '') {
        if (this.map.hasLayer(this.$store.state.xzLayer) == true) {
          this.map.removeLayer(this.$store.state.xzLayer);
        }
      }
    },
    xianValue(data) {
      if (data == '') {
        if (this.map.hasLayer(this.$store.state.xzLayer) == true) {
          this.map.removeLayer(this.$store.state.xzLayer);
        }
      }
    },
    nowxingzhengCodes(newVal, oldVal) {
      this.value1 = this.$store.state.ydbryorssShow;
    },
  },
  methods: {

    initRegionFun() {
      initRegion().then((res) => {
        // console.log('gis--->', res)
        this.sheng = res.sheng;
        this.shi = res.shi;
        this.xian = res.xian;
        if (this.sheng.length == 1) {
          this.shengValue = this.sheng[0].regionName;
          this.disabled1 = true;
        } else {
          this.shengValue = '';
          this.disabled1 = false;
        }
        if (this.shi.length == 1) {
          this.shiValue = this.shi[0].regionName;
          this.disabled2 = true;
        } else {
          this.shiValue = '';
          this.disabled2 = false;
        }
        if (this.xian.length == 1) {
          this.xianValue = this.xian[0].regionName;
          this.disabled3 = true;
        } else {
          this.xianValue = '';
          this.disabled3 = false;
        }

        if (this.xianValue != '') {
          this.$store.commit('nowxingzhengFun', this.xian[0].regionCode); //token
        } else if (this.shiValue != '') {
          this.$store.commit('nowxingzhengFun', this.shi[0].regionCode); //token
        } else if (this.shengValue != '') {
          this.$store.commit('nowxingzhengFun', this.sheng[0].regionCode); //token
        } else {
          this.$store.commit('nowxingzhengFun', '000000'); //token
        }
      })
    },
    shengChange(value) {
      if (value == '') {
        this.$store.commit('nowxingzhengFun', '000000'); //token
      } else {
        this.shengCode = value;
        this.$store.commit('nowxingzhengFun', value); //token
      }
      let params = {
        regionCode: value
      };
      getRegion(params).then((res) => {
        // console.log(res)
        this.shi = res.data;
      });
      this.shiValue = '';
      this.xianValue = '';
    },
    shiChange(value) {
      if (value == '') {
        this.$store.commit('nowxingzhengFun', this.shengCode); //token
      } else {
        this.shiCode = value;
        this.$store.commit('nowxingzhengFun', value); //token
      }
      let params = {
        regionCode: value
      };
      getRegion(params).then((res) => {
        // console.log(res)
        this.xian = res.data;
      });
      this.xianValue = '';
    },
    xianChange(value) {
      if (value == '') {
        this.$store.commit('nowxingzhengFun', this.shiCode); //token
      } else {
        this.xianCode = value;
        this.$store.commit('nowxingzhengFun', value); //token
      }
    },
    switchChange(value) {
      // console.log('222------------->', value)
      this.$store.commit('ydbAllShowFun', value); //token
      if (value == true) {
        this.value1 = false;
        this.new_value = false;
        this.$store.commit('xjydbShowFn', false); //token

        this.value4 = false;
        this.$store.commit('monitorydbShowFn', false);

      }
    },
    switchChange1(value) {
      console.log(value, 'ydbryorssShowFun下游有人')
      this.$store.commit('ydbryorssShowFun', value); //token
      if (value == true) {
        this.value = false;
      }
    },
    switchChange2(value) {
      this.$store.commit('nishaLayerShowFun1', value); //token
      // if (value == true) {
      //   this.value2 = false;
      // }
    },
    switchChange3(value) {
      this.$store.commit('nishaLayerShowFun2', value); //token
      // if (value == true) {
      //   this.value3 = false;
      // }
    },
    newswitchChange(val) {
      // console.log('111------------->', val)
      this.$store.commit('xjydbShowFn', val); //token
      if (val == true) {
        this.$store.commit('ydbAllShowFun', false); //token
        this.value = false;

        this.value4 = false;
        this.$store.commit('monitorydbShowFn', false);
      }
    },
    showNewYdbFn() {
      this.$emit("showNewYdb", true);
    },
    // switchChange4(value) {
    //   // console.log('222------------->', value)
    //   this.$store.commit('monitorydbShowFn', value); //token
    //   if (value == true) {
    //     this.$store.commit('ydbAllShowFun', false); //token
    //     this.value = false;

    //     this.value1 = false;
    //     this.new_value = false;
    //     this.$store.commit('xjydbShowFn', false); //token
    //   }else{
    //     this.value = true;
    //     this.$store.commit('ydbAllShowFun', true);
    //   }
    // },
    switchChange4(value) {
      this.$store.commit('monitorydbShowFn', value);

      this.paramsSingleDam.yjk = value;

      if (value) {
        // this.$store.commit('ydbAllShowFun', false);
        // this.value = false;
        this.new_value = false;
        this.$store.commit('xjydbShowFn', false);

        this.handleMonitoringLayer(value);
      } else {
        // this.value = true;
        // this.$store.commit('ydbAllShowFun', true);

        if (this.monitorMarkerLayer) {
          this.monitorMarkerLayer.clearLayers();
        }
      }
    },
    async handleMonitoringLayer(show) {
    if (!show) return;

    const params = {
      yjk: true,
      xyyr: false,
        // 重要设施
        zyss: false,
        //有蓄水
        yxs: false,
        yya: false,
        //黄委直管
        hwzg: false,
        //大型坝
        dxDam: false,
        //中型坝
        zxDam: false,
        //小型坝
        xxDam: false,
        //省
        provinceCode: '',
        //市
        cityCode: '',
        // 县
        countyCode: ''
    };

    if (this.monitorMarkerLayer) {
      this.monitorMarkerLayer.clearLayers();
    } else {
      this.monitorMarkerLayer = canvasMarkerLayer({
        zIndex: 10,
        collisionFlg: true,
        densityFactor: 0.4
      }).addTo(this.map);
    }

    try {
      const { data } = await getQueryDamDisData(params);

      const markers = this.addDevices(data, 'YJK');
      this.monitorMarkerLayer.addLayers(markers);
      this.monitorMarkerLayer.addOnHoverListener((event, item) => {
              if (item && event.target.getZoom() >= 8) {
                const offset = event.containerPoint
                if (Array.isArray(item) && item.length > 0) {
                  this.$store.commit('setAllLocation', offset)
                  this.$store.commit('setNewMarkerPopupData', item[0].data.data)
                }
              }
              // else {
              //   this.$store.commit('setNewMarkerPopupData', null)
              // }
            })




    } catch (error) {
      console.error('获取监控淤地坝数据失败:', error);
    }
  },

  addDevices(data, deviceType) {
    const markers = [];
    if (data && Array.isArray(data)) {
      data.forEach(item => {
        if (String(item.lat) && String(item.lon) &&
            String(item.lat) != 'NULL' && String(item.lon) != 'NULL') {
          const icon = L.icon({
            iconUrl: `/images/${deviceType}.png`,
            iconSize: [20, 20],
            iconAnchor: [10, 9]
          });
          const marker = L.marker([item.lat, item.lon], { icon });
          marker.data = item;
          markers.push(marker);
        }
      });
    }
    return markers;
  },
    clearAllLayers() {
    const map = this.map;

    // 清理监控淤地坝图层
    if (this.monitorMarkerLayer) {
      this.monitorMarkerLayer.clearLayers();
      map.removeLayer(this.monitorMarkerLayer);
      this.monitorMarkerLayer = null;
    }

    if (map.hasLayer(this.$store.state.xzLayer)) {
      map.removeLayer(this.$store.state.xzLayer);
    }
  },

  resetAllData() {
    this.shengValue = '';
    this.shiValue = '';
    this.xianValue = '';
    this.value = true;
    this.value1 = false;
    this.value2 = false;
    this.value3 = false;
    this.new_value = false;
    this.value4 = false;

    // 重置区域数据
    this.sheng = [];
    this.shi = [];
    this.xian = [];

    // 重置参数对象
    this.paramsSingleDam = {
      xyyr: false,
      zyss: false,
      yxs: false,
      yjk: false,
      yya: false,
      hwzg: false,
      dxDam: false,
      zxDam: false,
      xxDam: false,
      provinceCode: '',
      cityCode: '',
      countyCode: ''
    };
  }
  },
  beforeDestroy() {
    this.clearAllLayers();
    this.resetAllData();
    this.$store.commit('ydbAllShowFun', false);
    this.$store.commit('setNewMarkerPopupData', null)
  },
}
</script>

<style scoped>
.selectTool {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-height: 500px;
  z-index: 100;
}

>>> .el-select {
  width: 120px !important;
}

>>> .el-input--suffix .el-input__inner {
  color: #fff !important;
  background: transparent;
  //border: 1px solid #00b3fe;
  //background-color: rgba(9, 34, 72, 0.5);
}

>>> .el-select-dropdown {
  background: transparent !important;
  border: 1px solid #00b3fe;
  background-color: rgba(9, 34, 72, 0.5) !important;
}

.elSwitch {
  height: 30px;
  width: 60%;
  line-height: 30px;
  margin-top: 10px;
  padding-left: 10px;
  border: 1px solid #00b3fe;
  background-color: rgba(9, 34, 72, 0.5);
}

.new_elSwitch {
  height: 30px;
  width: 41%;
  line-height: 30px;
  margin-top: 10px;
  padding-left: 10px;
  border: 1px solid #00b3fe;
  background-color: rgba(9, 34, 72, 0.5);
}

.new_button {
  margin-top: 10px;
}

.elSwitch1 {
  height: 30px;
  width: 63%;
  line-height: 30px;
  margin-top: 10px;
  padding-left: 10px;
  border: 1px solid #00b3fe;
  background-color: rgba(9, 34, 72, 0.5);
}

.elSwitch2 {
  height: 30px;
  width: 94%;
  line-height: 30px;
  margin-top: 10px;
  padding-left: 10px;
  border: 1px solid #00b3fe;
  background-color: rgba(9, 34, 72, 0.5);
}

.elSwitch3 {
  height: 30px;
  width: 42%;
  line-height: 30px;
  margin-top: 10px;
  padding-left: 10px;
  border: 1px solid #00b3fe;
  background-color: rgba(9, 34, 72, 0.5);
}

.dtjbutton {
  height: 40px;
  width: 40%;
  line-height: 40px;
  margin-top: 10px;
  padding: 0;
}

>>> .el-switch__label {
  color: #fff;
  height: 30px;
  line-height: 30px;
}

>>> .el-switch__label.is-active {
  color: #409eff;
}

>>> .el-button {
  color: #fff;
  border: 1px solid #00b3fe;
  background-color: rgba(9, 34, 72, 0.5);
}

.elSwitch2 {
  /* 保持与有监控复选框相同的样式 */
  height: 30px;
  width: 94%;
  line-height: 30px;
  margin-top: 10px;
  padding-left: 10px;
  border: 1px solid #00b3fe;
  background-color: rgba(9, 34, 72, 0.5);
  color: #fff;
}

>>> .el-switch__label {
  color: #fff;
  height: 30px;
  line-height: 30px;
}

>>> .el-switch__label.is-active {
  color: #409eff;
}
</style>
